// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SignForm_wrapper__2GoRW"};